/* ==========================================================================
   AURRA — two-color pair builder

   Every color gets a photograph and its own size row. Pick a size for each,
   add the pair in one action. The discount is a Shopify automatic discount applied
   at checkout (Henley: 10% off both; Lace Top: 20 EGP off each, minimum quantity 2);
   the snippet passes mode + value, this file only does arithmetic for display.

   The pair is independent of the variant picker above. It seeds from whatever
   size is selected there, because that is the customer's own signal about
   their size, but every choice stays theirs to change.
   ========================================================================== */
(function () {
  'use strict';

  try {
    var root = document.querySelector('[data-aurra-bundle]');
    if (!root) return;

    var variants = JSON.parse(root.querySelector('[data-aurra-bundle-variants]').textContent);
    var colors = JSON.parse(root.querySelector('[data-aurra-bundle-colors]').textContent);
    var line = root.querySelector('[data-aurra-bundle-line]');
    var colsBox = root.querySelector('[data-aurra-bundle-cols]');
    var hint = root.querySelector('[data-aurra-bundle-hint]');
    var btn = root.querySelector('[data-aurra-bundle-add]');
    var labelEl = root.querySelector('[data-aurra-bundle-label]');
    var idInput = document.querySelector('.product-form [name="id"]');

    var MODE = root.getAttribute('data-aurra-bundle-mode') || 'percent';
    var VALUE = parseFloat(root.getAttribute('data-aurra-bundle-value'));
    if (isNaN(VALUE)) VALUE = MODE === 'each' ? 0 : 0.1;

    function money(cents) {
      return Math.round(cents / 100).toLocaleString('en-US') + ' EGP';
    }
    function find(color, size) {
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].color === color && variants[i].size === size) return variants[i];
      }
      return null;
    }
    function sizesFor(color) {
      var out = [];
      variants.forEach(function (v) {
        if (v.color === color && out.indexOf(v.size) === -1) out.push(v.size);
      });
      return out;
    }
    function firstAvailableSize(color) {
      var s = sizesFor(color).filter(function (x) {
        var v = find(color, x);
        return v && v.available;
      });
      return s[0] || null;
    }

    /* Only colors that can actually be bought get a column. */
    var live = colors.filter(function (c) { return firstAvailableSize(c.name); });
    if (live.length < 2) return;                 /* no pair is possible */

    /* color name -> chosen size */
    var chosen = {};

    function seed() {
      var cur = null;
      if (idInput) {
        cur = variants.filter(function (v) {
          return String(v.id) === String(idInput.value);
        })[0];
      }
      live.forEach(function (c) {
        if (chosen[c.name]) return;
        var want = cur && find(c.name, cur.size);
        chosen[c.name] = (want && want.available) ? cur.size : firstAvailableSize(c.name);
      });
    }

    function selected() {
      return live.map(function (c) { return find(c.name, chosen[c.name]); })
                 .filter(function (v) { return v && v.available; });
    }

    function render() {
      seed();
      colsBox.innerHTML = '';

      live.forEach(function (c) {
        var col = document.createElement('div');
        col.className = 'aurra-bundle__col';

        col.innerHTML =
          (c.img
            ? '<img class="aurra-bundle__img" src="' + c.img + '" alt="' + c.name +
              '" loading="eager" decoding="async">'
            : '<span class="aurra-bundle__img aurra-bundle__img--blank" aria-hidden="true"></span>') +
          '<span class="aurra-bundle__name">' + c.name + '</span>';

        var row = document.createElement('div');
        row.className = 'aurra-bundle__sizes';
        row.setAttribute('role', 'radiogroup');
        row.setAttribute('aria-label', c.name + ' size');

        sizesFor(c.name).forEach(function (s) {
          var v = find(c.name, s);
          var out = !v || !v.available;
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'aurra-bundle__size' +
            (s === chosen[c.name] && !out ? ' is-on' : '') +
            (out ? ' is-out' : '');
          b.textContent = s;
          b.setAttribute('role', 'radio');
          b.setAttribute('aria-checked', String(s === chosen[c.name] && !out));
          if (out) {
            b.disabled = true;
            b.title = 'Sold out';
          } else {
            b.addEventListener('click', function () {
              chosen[c.name] = s;
              render();
            });
          }
          row.appendChild(b);
        });

        col.appendChild(row);
        colsBox.appendChild(col);
      });

      var picks = selected();
      var complete = picks.length === live.length;
      var full = picks.reduce(function (n, v) { return n + v.price; }, 0);
      var discounted = MODE === 'each' ? full - VALUE * picks.length : Math.round(full * (1 - VALUE));

      if (complete) {
        line.innerHTML =
          'Two pieces — <strong>' + money(discounted) + '</strong> instead of ' +
          money(full) + '. That is ' + money(Math.round(discounted / picks.length)) +
          ' each, and you save ' + money(full - discounted) + '.';
        labelEl.textContent = 'Add both to cart — ' + money(discounted);
        hint.setAttribute('hidden', '');
      } else {
        labelEl.textContent = 'Add both to cart';
        hint.removeAttribute('hidden');
      }
      btn.disabled = !complete;
      root.removeAttribute('hidden');
    }

    render();

    /* Reseed sizes from the picker above only while the customer has not
       touched this block — once they have chosen, their choice stands. */
    if (idInput && window.MutationObserver) {
      new MutationObserver(function () {
        chosen = {};
        render();
      }).observe(idInput, { attributes: true, attributeFilter: ['value'] });
    }

    btn.addEventListener('click', function () {
      var picks = selected();
      if (picks.length !== live.length || btn.disabled) return;

      btn.disabled = true;
      var restore = labelEl.textContent;
      labelEl.textContent = 'Adding…';

      /* Dawn's own drawer contract: ask for its sections in the add, then hand
         the response to renderContents, which repaints and opens the drawer.
         Reimplementing that rendering is how these blocks drift out of date. */
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var body = {
        items: picks.map(function (v) { return { id: v.id, quantity: 1 }; })
      };
      if (cart && cart.getSectionsToRender) {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function (state) {
          /* This theme uses cart-notification, whose getSectionsToRender()
             builds a selector from parsedState.key. A MULTI-item /cart/add.js
             response carries no top-level key — only items[] — so the selector
             resolved to "...-undefined", rendering threw, and the notification
             never opened even though the add had succeeded. Borrow the first
             added item's key. */
          if (state && !state.key && state.items && state.items.length) {
            state.key = state.items[0].key;
          }
          try {
            if (cart && cart.renderContents && state.sections) {
              cart.renderContents(state);
              return;
            }
          } catch (err) {
            if (window.console && console.warn) console.warn('[aurra-bundle-offer] render', err);
          }
          window.location = '/cart';
        })
        .catch(function () {
          labelEl.textContent = 'Could not add — try again';
        })
        .finally(function () {
          setTimeout(function () {
            btn.disabled = false;
            if (labelEl.textContent === 'Adding…') labelEl.textContent = restore;
          }, 1200);
        });
    });
  } catch (e) {
    if (window.console && console.warn) console.warn('[aurra-bundle-offer]', e);
  }
})();
